import { render, staticRenderFns } from "./PurchaseSelectProducts.vue?vue&type=template&id=65485863&scoped=true&"
import script from "./PurchaseSelectProducts.vue?vue&type=script&lang=js&"
export * from "./PurchaseSelectProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65485863",
  null
  
)

export default component.exports